import {
  rangeLabel,
  resolvePlayer,
  resolveStats,
  upcomingFixtures
} from './block-helpers';
import { PlayerProfileCard } from './PlayerProfileCard';
import { buildStatRows, DEFAULT_STAT_MODE } from '@lib/article-blocks/stats';
import type {
  ArticleBlockData,
  SanityPlayerProfileBlock
} from '@lib/article-blocks/types';

type PlayerProfileBlockProps = {
  value: SanityPlayerProfileBlock;
  data: ArticleBlockData;
};

export const PlayerProfileBlock = ({
  value,
  data
}: PlayerProfileBlockProps) => {
  const player = resolvePlayer(data, value.player);
  if (!player) return null;

  const stats = resolveStats(
    data,
    value.venue,
    value.gameweekRange,
    player.externalIds.optaUuid
  );

  return (
    <PlayerProfileCard
      player={player}
      stats={buildStatRows(stats, value.statMode ?? DEFAULT_STAT_MODE)}
      rangeLabel={rangeLabel(value.gameweekRange, data.currentGameweek)}
      upcoming={upcomingFixtures(data, player.team.shortName)}
    />
  );
};
